const initial =
  'h-[20px] max-h-[20px] w-[20px] min-w-[20px] max-w-[20px] mr-3 cursor-pointer appearance-none items-center border rounded-[20px] content-[""] inline-block relative visible'

const checked =
  'checked:after:border-[5px] checked:after:rounded-[20px] checked:after:content-[""] checked:after:inline-block checked:after:absolute checked:after:top-[-1px] checked:after:left-[-1px] checked:after:h-[20px] checked:after:min-w-[20px] checked:after:max-w-[20px] checked:after:max-h-[20px]'

const disabled = 'disabled:pointer-events-none'

export const defaultRadio = `${initial} ${checked} ${disabled}`
